<template>
  <v-row no-gutters>
    <v-col class="pa-0">
      <v-card
        class="pa-4 mb-2 pb-0 rounded-lg"
        elevation="0"
        color="grey lighten-3"
      >
        <v-card-title class="text-left subtitle-1 px-0 pt-0 pb-2">
          Добавление территории:
        </v-card-title>
        <v-row no-gutters class="pa-0">
          <v-col cols="10" md="11" class="pr-md-1">
            <v-autocomplete
              class="pa-0"
              v-model="item.uid"
              :items="selectors"
              outlined
              item-value="uid"
              item-text="name"
              :error="hasSpecialError('territories')"
              :error-messages="getSpecialError('territories')"
            >
              <template v-slot:label>
                Территория <strong class="red--text">*</strong>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="2" md="1">
            <v-btn
              v-if="territories.length>1"
              icon
              @click="removeTerritory(index)"
              class="pr-0"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "Territories",
  props: {
    item: Object,
    index: Number,
    territories: Array,
    selectors: Array,
    specialError: Array
  },
  components: {},
  mixins: [],
  data() {
    return {
    }
  },
  watch: {},
  computed: {
  },
  methods: {
    // Удаление одной из территорий
    removeTerritory(index) {
      this.territories.splice(index, 1)
    },
    // Функция для проверки наличия специфичных ошибок
    hasSpecialError(field, include_field) {
      let result = this.specialError[this.index]
      if (include_field) {
        if (result)
          if(result[field]) {
            let result_include = result[field]
            if (result_include[include_field])
              return true
          }
      } else {
        if (result)
          if(result[field])
            return true
        return false
      }
    },
    // Функция для отображения специфичных ошибок
    getSpecialError(field, include_field) {
      let result = this.specialError[this.index]
      if (include_field) {
        if(result) {
          let result_include = result[field]
          if (result_include)
            return result_include[include_field]
        }
      } else {
        if (result)
          return result[field]
        return ""
      }
    }
  }

}
</script>

<style scoped>

</style>
